import { Reducer } from 'redux';
import { ExpandedKeysActions, ExpandedKeysActionTypes } from './expandedKeysActions';

export interface ExpandedKeysState {
    projectVersionExpandedKeys: Record<string, string[]>;
    projectVariantVersionExpandedKeys: Record<string, string[]>;
    softwareComponentsExpandedKeys: Record<string, string[]>;
    autosarComponentExpandedKeys: Record<string, string[]>;
    compositionExpandedKeys: Record<string, string[]>;
    dataDictionaryExpandedKeys: Record<string, string[]>;
    dataElementDefinitionsExpandedKeys: Record<string, string[]>;
    operationDefinitionsExpandedKeys: Record<string, string[]>;
    triggerDefinitionsExpandedKeys: Record<string, string[]>;
    collapsiblesExpanded: Record<string, boolean>;
}

export const defaultState: ExpandedKeysState = {
    projectVersionExpandedKeys: {},
    projectVariantVersionExpandedKeys: {},
    softwareComponentsExpandedKeys: {},
    autosarComponentExpandedKeys: {},
    compositionExpandedKeys: {},
    dataDictionaryExpandedKeys: {},
    dataElementDefinitionsExpandedKeys: {},
    operationDefinitionsExpandedKeys: {},
    triggerDefinitionsExpandedKeys: {},
    collapsiblesExpanded: {},
};

export const expandedKeysReducer: Reducer<ExpandedKeysState, ExpandedKeysActions> = (state = defaultState, action: ExpandedKeysActions) => {
    switch (action.type) {
        case ExpandedKeysActionTypes.SET_PROJECT_VERSION_EXPANDED_KEYS:
            const newProjectVersionExpandedKeys = state.projectVersionExpandedKeys ? state.projectVersionExpandedKeys : {};
            newProjectVersionExpandedKeys[action.payload.id] = action.payload.expandedKeys;
            return {
                ...state,
                projectVersionExpandedKeys: newProjectVersionExpandedKeys,
            };
        case ExpandedKeysActionTypes.SET_PROJECT_VARIANT_VERSION_EXPANDED_KEYS:
            const newProjectVariantVersionExpandedKeys = state.projectVariantVersionExpandedKeys ? state.projectVariantVersionExpandedKeys : {};
            newProjectVariantVersionExpandedKeys[action.payload.id] = action.payload.expandedKeys;
            return {
                ...state,
                projectVariantVersionExpandedKeys: newProjectVariantVersionExpandedKeys,
            };
        case ExpandedKeysActionTypes.SET_SOFTWARE_COMPONENTS_EXPANDED_KEYS:
            const newSoftwareComponentsExpandedKeys = state.softwareComponentsExpandedKeys ? state.softwareComponentsExpandedKeys : {};
            newSoftwareComponentsExpandedKeys[action.payload.id] = action.payload.expandedKeys;
            return {
                ...state,
                softwareComponentsExpandedKeys: newSoftwareComponentsExpandedKeys,
            };
        case ExpandedKeysActionTypes.SET_DATA_ELEMENT_DEFINITIONS_EXPANDED_KEYS:
            const newDataElementDefinitionsExpandedKeys = state.dataElementDefinitionsExpandedKeys ? state.dataElementDefinitionsExpandedKeys : {};
            newDataElementDefinitionsExpandedKeys[action.payload.id] = action.payload.expandedKeys;
            return {
                ...state,
                dataElementDefinitionsExpandedKeys: newDataElementDefinitionsExpandedKeys,
            };
        case ExpandedKeysActionTypes.SET_OPERATION_DEFINITIONS_EXPANDED_KEYS:
            const newOperationDefinitionsExpandedKeys = state.operationDefinitionsExpandedKeys ? state.operationDefinitionsExpandedKeys : {};
            newOperationDefinitionsExpandedKeys[action.payload.id] = action.payload.expandedKeys;
            return {
                ...state,
                operationDefinitionsExpandedKeys: newOperationDefinitionsExpandedKeys,
            };
        case ExpandedKeysActionTypes.SET_TRIGGER_DEFINITIONS_EXPANDED_KEYS:
            const newTriggerDefinitionsExpandedKeys = state.triggerDefinitionsExpandedKeys ? state.triggerDefinitionsExpandedKeys : {};
            newTriggerDefinitionsExpandedKeys[action.payload.id] = action.payload.expandedKeys;
            return {
                ...state,
                triggerDefinitionsExpandedKeys: newTriggerDefinitionsExpandedKeys,
            };
        case ExpandedKeysActionTypes.SET_AUTOSAR_COMPONENT_EXPANDED_KEYS:
            const newAutosarComponentExpandedKeys = state.autosarComponentExpandedKeys ? state.autosarComponentExpandedKeys : {};
            newAutosarComponentExpandedKeys[action.payload.id] = action.payload.expandedKeys;
            return {
                ...state,
                autosarComponentExpandedKeys: newAutosarComponentExpandedKeys,
            };
        case ExpandedKeysActionTypes.SET_COMPOSITION_EXPANDED_KEYS:
            const newCompositionExpandedKeys = state.compositionExpandedKeys ? state.compositionExpandedKeys : {};
            newCompositionExpandedKeys[action.payload.id] = action.payload.expandedKeys;
            return {
                ...state,
                compositionExpandedKeys: newCompositionExpandedKeys,
            };
        case ExpandedKeysActionTypes.SET_DATA_DICTIONARY_EXPANDED_KEYS:
            const newDataDictionaryExpandedKeys = state.dataDictionaryExpandedKeys ? state.dataDictionaryExpandedKeys : {};
            newDataDictionaryExpandedKeys[action.payload.id] = action.payload.expandedKeys;
            return {
                ...state,
                dataDictionaryExpandedKeys: newDataDictionaryExpandedKeys,
            };
        case ExpandedKeysActionTypes.SET_COLLAPSIBLES_EXPANDED_KEYS:
            const newExpanded = state.collapsiblesExpanded ? state.collapsiblesExpanded : {};
            newExpanded[action.payload.key] = action.payload.isOpen;
            return {
                ...state,
                collapsiblesExpanded: newExpanded,
            };
        default: {
            return state;
        }
    }
};
